import { useState } from "react";
import { X } from "lucide-react";

export const TagsInput = ({ value = [], onChange, suggestions = [], testid }) => {
  const [text, setText] = useState("");
  const listId = `${testid}-list`;
  const add = (raw) => {
    const t = raw.trim().replace(/,$/, "");
    if (t && !value.some((v) => v.toLowerCase() === t.toLowerCase())) onChange([...value, t]);
    setText("");
  };
  return (
    <div className="c-input !p-2 flex flex-wrap gap-1.5" data-testid={testid}>
      {value.map((v) => (
        <span key={v} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-[var(--c-elev)]">
          {v}
          <button type="button" aria-label={`Quitar ${v}`} onClick={() => onChange(value.filter((x) => x !== v))}><X className="w-3 h-3" /></button>
        </span>
      ))}
      <input
        list={listId}
        data-testid={`${testid}-input`}
        value={text}
        onChange={(e) => (e.target.value.endsWith(",") ? add(e.target.value) : setText(e.target.value))}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(text); } }}
        onBlur={() => text && add(text)}
        placeholder={value.length ? "" : "Escribe y presiona Enter"}
        className="flex-1 min-w-[8rem] bg-transparent outline-none text-[16px] px-1"
      />
      <datalist id={listId}>{suggestions.map((s) => <option key={s} value={s} />)}</datalist>
    </div>
  );
};
